import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';

@Component({
  selector: 'app-modal-new-employee-job',
  templateUrl: './modal-new-employee-job.component.html',
  styleUrls: ['./modal-new-employee-job.component.css']
})
export class ModalNewEmployeeJobComponent implements OnInit {
  @Input() position: CatEmployeeJobModel;
  @Input() mode: string;

  // estado pagina
  public viewStatus = 1;

  // mascaras
  public customPatterns = {
    'A': { pattern: new RegExp('[a-zA-Z0-9ñÑ ]') },
    'C': { pattern: new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]') },
    'N': { pattern: new RegExp('[0-9]') }
  };

  ////////////////
  constructor(
    private employeeJobService: CatEmployeeJobService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }
  ngOnInit() { }

  //
  toggleActive = () => this.position.activeId = !this.position.activeId;
  isValid = () => {
    let valid = true;
    let errors = [];
    if (this.descriptionError()) errors.push('Necesita capturar una descripción.');
    if (errors.length > 0) {
      valid = false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', { enableHtml: true });
    }
    return valid;
  }
  save = () => {
    if (this.isValid()) {
      // mostrar spinner
      this.viewStatus = 0;
      // enviar informacion
      this.position.description = this.position.description.toUpperCase();
      this.employeeJobService.save(this.position)
        .pipe(
          tap((resp: any) => {
            if (resp && resp.codeHttpStatus === 200) {
              this.modalService.dismissAll('success');
              this.toastr.success('El puesto se guardó con éxito.');
            } else {
              this.viewStatus = 1;
              this.toastr.error(resp && resp.messageError ? resp.messageError : 'Ocurrió un error al intentar guardar el puesto.');
            }
          }),
          catchError(error => {
            this.viewStatus = 1;
            return of(this.toastr.error('Ocurrió un error al intentar guardar el puesto.'));
          })
        )
        .subscribe();
    }
  }
  close = () => this.modalService.dismissAll();

  // HELPERS
  descriptionError = () => !this.position.description || this.position.description.trim() === '';
}
